/**
 * Resolver dinâmico de ícones Lucide por NOME (string vinda do backend).
 *
 * Uso:
 *   import { getLucideIcon } from "@/lib/lucideIcon";
 *   const Icon = getLucideIcon(product.icon); // fallback Sparkles
 *   <Icon className="w-5 h-5" />
 *
 * Aceita qualquer PascalCase válido do lucide-react (~1000 ícones).
 * Também aceita apelidos comuns (Bank → Landmark).
 */
import * as LucideAll from "lucide-react";
import { Sparkles } from "lucide-react";

// Apelidos → nome canonizado do lucide-react
const ALIASES = {
  Bank: "Landmark",
  Balance: "Scale",
  Court: "Gavel",
  Doc: "FileText",
  Person: "User",
  People: "Users",
  Company: "Building2",
  Money: "DollarSign",
  Money$: "DollarSign",
  Chart: "BarChart3",
  Graph: "LineChart",
  Warning: "AlertTriangle",
};

export function getLucideIcon(name, fallback = Sparkles) {
  if (!name || typeof name !== "string") return fallback;
  const key = ALIASES[name] || name;
  const Ico = LucideAll[key];
  if (Ico && typeof Ico === "object") return Ico;
  if (typeof Ico === "function") return Ico;
  return fallback;
}
